import type { AdditionalSelectors } from '../types';

export let fuelSavingAdditionalSelectors: AdditionalSelectors | undefined;

export const init = (additionalSelectors: AdditionalSelectors): { additionalSelectors: AdditionalSelectors } => {
    fuelSavingAdditionalSelectors = additionalSelectors;

    return {
        additionalSelectors: fuelSavingAdditionalSelectors
    };
};

export const getFuelSavingAdditionalSelectors = (): AdditionalSelectors | undefined => fuelSavingAdditionalSelectors;
